export const MESSAGE_TYPE_STANDARD = "STANDARD";
export const MESSAGE_TYPE_IMPORTANT = "IMPORTANT";
export const MESSAGE_TYPE_PRIORITY = "PRIORITY";
export const MESSAGE_TYPE_CRITICAL = "CRITICAL";

export const MESSAGE_ALERT_TYPES = [MESSAGE_TYPE_CRITICAL, MESSAGE_TYPE_PRIORITY, MESSAGE_TYPE_IMPORTANT];
